<div class="guidance-container mt-20">
  @if (fileDirectoryHandler() && cancelAccessAuthorisation() && !file()) {
    <div class="guidance-access">
      <div class="bold subtitle-2 no-result">
        EstImage was not given access to the {{ type | titlecase }} import folder.
      </div>
      <div class="body-1">
        <span class="link" (click)="givePermissionToFileAccess()">Click here</span> to give EstImage access to the quote
        import folder or you may click browse to find your {{ type | titlecase }}
      </div>
    </div>
  }
  @if (fileDirectoryHandler() && !rego && !xmlFiles?.length) {
    <div class="bold subtitle-2 no-result">
      There is no REGO set on the job. Please browse to find your {{ type | titlecase }}
    </div>
  }
  @if (fileDirectoryHandler() && rego && permissionOfFileWasGiven() && noFile() && !xmlFiles?.length) {
    <div class="bold subtitle-2 no-result">
      EstImage could not find {{ type === 'invoice' ? 'an' : 'a' }} {{ type | titlecase }} with rego {{ rego }}. Please
      browse to find your {{ type | titlecase }}
    </div>
  }
  @if (
    fileDirectoryHandler() &&
    !(permissionOfFileWasGiven() && permissionOfImagesWasGiven()) &&
    !cancelAccessAuthorisation() &&
    rego &&
    !file() &&
    !fileDeleted &&
    !xmlFiles
  ) {
    <div class="guidance-access subtitle-2">
      <div>Your browser may ask you to allow EstImage to view the files in these folders.</div>
      <div class="bold"><span class="view-files">Click "View Files" </span>to give EstImage access.</div>
    </div>
  }
  <div class="guidance-information">
    @if (!fileDirectoryHandler()) {
      <div>
        @if (!fileDirectoryHandler()) {
          <ng-container
            [ngTemplateOutlet]="guidanceInfo"
            [ngTemplateOutletContext]="{ message: 'Select ' + (type | titlecase) + ' folder', icon: 'folder_open' }">
          </ng-container>
        }
      </div>
    } @else {
      <div class="directories-name">
        @if (fileDirectoryHandler()) {
          <ng-container
            [ngTemplateOutlet]="guidanceInfo"
            [ngTemplateOutletContext]="{
              message: (type | titlecase) + ' folder: ',
              folderName: fileDirectoryHandler()?.name,
              icon: 'folder_open'
            }">
          </ng-container>
        }
        @if (imagesDirectoryHandler()) {
          <ng-container
            [ngTemplateOutlet]="guidanceInfo"
            [ngTemplateOutletContext]="{
              message: 'Image folder: ',
              folderName: imagesDirectoryHandler()?.name,
              icon: 'crop_original'
            }">
          </ng-container>
        }
      </div>
    }
    <button
      type="button"
      matButton="elevated"
      class="charcoal-button w-36! min-w-36! p-0!"
      (click)="configureImportDirectories()">
      <mat-icon class="m-0!" svgIcon="folder_edit" />
    </button>
  </div>
</div>

<ng-template #guidanceInfo let-message="message" let-icon="icon" let-folderName="folderName">
  <div class="information">
    <mat-icon>{{ icon }}</mat-icon>
    <div class="subtitle-2 message">
      {{ message }} <span class="bold">{{ folderName }}</span>
    </div>
  </div>
</ng-template>
